export const BBOX_GERMANY = [5.72, 47.15, 15.24, 54.93]; // const [minLong, minLat, maxLong, maxLat] = BBOX_GERMANY

const mobileStepperZIndex = 1000; // https://mui.com/material-ui/customization/z-index/
export const zIndexRange3dHtml = [mobileStepperZIndex, 1]; // This makes sure that all of the Three-rendered stuff stays behind the MUI stuff
